import React, { useEffect, useState } from "react";
import { CandidateService } from "../../../../services/candidateService";
import { prepareCandidateData } from "../../../../utils/dataTableUtilsAdmin";
import { CandidatesTable } from "../candidate-listing-table/candidatesTables";
import { QueryClient, QueryClientProvider } from "react-query";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import Loader from "react-spinner-loader";
import { Form, Col } from "react-bootstrap";
import SigniteButton from "../../../ui-elements/signite-button/signiteButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import '../candidate-listing-table/candidatesTables.css';
import { NavDropdown } from "react-bootstrap";
import { useQueryClient } from "@tanstack/react-query";
const UnapprovedCandidates = () => {
    const [loader, setLoader] = useState(false);
    const queryClient = useQueryClient();
    const [candidateId, setCandidateId] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [designation, setDesignation] = useState('');
    const [yearsOfExp, setYearsOfExp] = useState(null);
    const [searchLocation, setSearchLocation] = useState('');
    const [industry, setIndustry] = useState('');
    const [ctcMin, setCtcMin] = useState(null);
    const [ctcMax, setCtcMax] = useState(null);

    const [updatedCandidateId, setUpdatedCandidateId] = useState('');
    const [updatedFirstName, setUpdatedFirstName] = useState('');
    const [updatedLastName, setUpdatedLastName] = useState('');
    const [updatedSearchLocation, setUpdatedSearchLocation] = useState('');
    const [updatedDesignation, setUpdatedDesignation] = useState('');
    const [updatedYearsOfExp, setUpdatedYearsOfExp] = useState(null);
    const [updatedIndustry, setUpdatedIndustry] = useState('');
    const [updatedCtcMin, setUpdatedCtcMin] = useState(null);
    const [updatedCtcMax, setUpdatedCtcMax] = useState(null);
    const [updatedCandidateApproved, setUpdatedCandidateApproved] = useState('');
    const [candiateTableData, setCandidateTableData] = useState({ columns: [], data: [] });
    const [candidateApproved, setCandidateApproved] = useState('');
    const [searchStatus, setSearchStatus] = useState('');
    const [validationStatus, setValidationStatus] = useState('');
    const [filterKey, setFilterKey] = useState(0);

    useEffect(() => {
        const savedState = sessionStorage.getItem('unapprovedCandidateSearchState');
        const savedPagination = sessionStorage.getItem('candidatePagination-unapproved');
        const candidateUpdated = sessionStorage.getItem('candidateUpdated');

        if (candidateUpdated === 'true') {
            queryClient.invalidateQueries(['data']); // ✅ Refresh table data
            sessionStorage.removeItem('candidateUpdated');
        }
        if (savedState) {
            const parsed = JSON.parse(savedState);
            setFirstName(parsed.firstName || '');
            setLastName(parsed.lastName || '');
            setSearchLocation(parsed.searchLocation || '');
            setDesignation(parsed.designation || '');
            setCandidateId(parsed.candidateId || '');
            setYearsOfExp(parsed.yearsOfExp ?? null);
            setIndustry(parsed.industry || '');
            setCtcMin(parsed.ctcMin ?? null);
            setCtcMax(parsed.ctcMax ?? null);
            setCandidateApproved(parsed.candidateApproved || '');
            setSearchStatus(parsed.searchStatus || '');
            setValidationStatus(parsed.validationStatus || '');

            setUpdatedFirstName(parsed.firstName || '');
            setUpdatedLastName(parsed.lastName || '');
            setUpdatedSearchLocation(parsed.searchLocation || '');
            setUpdatedDesignation(parsed.designation || '');
            setUpdatedCandidateId(parsed.candidateId || '');
            setUpdatedYearsOfExp(parsed.yearsOfExp ?? null);
            setUpdatedIndustry(parsed.industry || '');
            setUpdatedCtcMin(parsed.ctcMin ?? null);
            setUpdatedCtcMax(parsed.ctcMax ?? null);

            if (parsed.candidateApproved || parsed.searchStatus || parsed.validationStatus) {
                setTimeout(() => searchCandidate(), 0);
            }
        }
        if (savedPagination) {
            const parsed = JSON.parse(savedPagination);
            sessionStorage.setItem('restorePagination', 'true');
            sessionStorage.setItem('restoredPageIndex-unapproved', parsed.pageIndex ?? 0);
            sessionStorage.setItem('restoredPageSize-unapproved', parsed.pageSize ?? 10);
        }

    }, [queryClient]);

    const searchCandidate = () => {
        const searchState = {
            firstName,
            lastName,
            searchLocation,
            designation,
            candidateId,
            yearsOfExp,
            industry,
            ctcMin,
            ctcMax,
            candidateApproved,
            searchStatus,
            validationStatus,
        };
        sessionStorage.setItem('unapprovedCandidateSearchState', JSON.stringify(searchState));
        sessionStorage.setItem(
            'candidatePagination-unapproved',
            JSON.stringify({ pageIndex: 0, pageSize: 10 })
        );
        setUpdatedFirstName(firstName);
        setUpdatedLastName(lastName);
        setUpdatedSearchLocation(searchLocation);
        setUpdatedDesignation(designation);
        setUpdatedCandidateId(candidateId);
        setUpdatedYearsOfExp(yearsOfExp);
        setUpdatedIndustry(industry);
        setUpdatedCtcMin(ctcMin);
        setUpdatedCtcMax(ctcMax);
        setFilterKey(prev => prev + 1);

    };

    const setSearchField = (event) => {
        const { id, value } = event.target;
        switch (id) {
            case 'candidateId': setCandidateId(value); break;
            case 'firstName': setFirstName(value); break;
            case 'lastName': setLastName(value); break;
            case 'designation': setDesignation(value); break;
            case 'yearsOfExp': setYearsOfExp(value ? parseInt(value, 10) : null); break;
            case 'location': setSearchLocation(value); break;
            case 'industry': setIndustry(value); break;
            case 'ctcMin': setCtcMin(value ? parseInt(value, 10) : null); break;
            case 'ctcMax': setCtcMax(value ? parseInt(value, 10) : null); break;

        }
    };

    const onKeyUp = (e) => {
        if (e.key === 'Enter') {
            searchCandidate();
        }
    };

    const fetchData = async ({ pageIndex, pageSize }) => {
        setLoader(true);
        try {
            const response = await CandidateService.getTLUnapprovedApprovalRequestedCandidates(
                candidateApproved,
                searchStatus,
                validationStatus,
                pageIndex,
                pageSize
            );

            const retData = response.data;
            setLoader(false);

            return {
                rows: prepareCandidateData(retData, null, true, true),
                pageCount: retData.pageCount,
            };
        } catch (err) {
            console.error("Failed to load TL unapproved candidates:", err);
            setLoader(false);
        }
    };

    const { columns, data } = candiateTableData;

    return (
        <Container fluid>
            <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
            <Row>
                <Card className="p-0">
                    <Card.Header>
                        <Form className="pr">
                            <Row className="align-items-center">
                                {/* <Col xs="auto" className="mb-2">
                                    <Form.Control id="candidateId" placeholder="Candidate ID" value={candidateId} onChange={setSearchField} onKeyUp={onKeyUp} spellCheck='false' />
                                </Col>
                                <Col xs="auto" className="mb-2">
                                    <Form.Control id="firstName" placeholder="First Name" value={firstName} onChange={setSearchField} onKeyUp={onKeyUp} spellCheck='false' />
                                </Col>
                                <Col xs="auto" className="mb-2">
                                    <Form.Control id="lastName" placeholder="Last Name" value={lastName} onChange={setSearchField} onKeyUp={onKeyUp} spellCheck='false' />
                                </Col>
                                <Col xs="auto" className="mb-2">
                                    <Form.Control id="designation" placeholder="Function" value={designation} onChange={setSearchField} onKeyUp={onKeyUp} spellCheck='false' />
                                </Col>
                                <Col xs="auto" className="mb-2">
                                    <Form.Control id="yearsOfExp" placeholder="Experience (Years)" value={yearsOfExp ?? ''} onChange={setSearchField} onKeyUp={onKeyUp} spellCheck='false' />
                                </Col>
                                <Col xs="auto" className="mb-2">
                                    <Form.Control id="location" placeholder="Location" value={searchLocation} onChange={setSearchField} onKeyUp={onKeyUp} spellCheck='false' />
                                </Col>
                                <Col xs="auto" className="mb-2">
                                    <Form.Control id="industry" placeholder="Industry" value={industry} onChange={setSearchField} onKeyUp={onKeyUp} spellCheck='false' />
                                </Col>
                                <Col xs="auto" className="mb-2">
                                    <Form.Control id="ctcMin" placeholder="CTC Min" value={ctcMin ?? ''} onChange={setSearchField} onKeyUp={onKeyUp} spellCheck='false' />
                                </Col>
                                <Col xs="auto" className="mb-2">
                                    <Form.Control id="ctcMax" placeholder="CTC Max" value={ctcMax ?? ''} onChange={setSearchField} onKeyUp={onKeyUp} spellCheck='false' />
                                </Col> */}
                                <Col xs="auto" className="mb-2">
                                    {/* <Form.Select
                                        id="candidateApproved"
                                        value={candidateApproved}
                                        onChange={(e) => {
                                            setCandidateApproved(e.target.value);
                                            searchCandidate();
                                        }}
                                        style={{ width: '230px', boxShadow:'none' }}
                                    >
                                        <option value="">All</option>
                                        <option value="Y">Candidate Approved</option>
                                        <option value="N">Candidate Unapproved</option>
                                    </Form.Select> */}
                                    <div className="dropdown-select-wrapper">

                                        <NavDropdown
                                            id="candidate-approved-dropdown"
                                            title={
                                                candidateApproved === "Y"
                                                    ? "Candidate Approved"
                                                    : candidateApproved === "N"
                                                        ? "Candidate Unapproved"
                                                        : "All"
                                            }
                                            className="custom-approval-dropdown"
                                        >
                                            <NavDropdown.Item
                                                onClick={() => {
                                                    setCandidateApproved('');
                                                    searchCandidate();
                                                }}
                                                className={`unapproved-dropdown-item ${candidateApproved === '' ? 'active' : ''}`}
                                            >
                                                All
                                            </NavDropdown.Item>
                                            <NavDropdown.Item
                                                onClick={() => {
                                                    setCandidateApproved('Y');
                                                    searchCandidate();
                                                }}
                                                className={`unapproved-dropdown-item ${candidateApproved === 'Y' ? 'active' : ''}`}
                                            >
                                                Candidate Approved
                                            </NavDropdown.Item>
                                            <NavDropdown.Item
                                                onClick={() => {
                                                    setCandidateApproved('N');
                                                    searchCandidate();
                                                }}
                                                className={`unapproved-dropdown-item ${candidateApproved === 'N' ? 'active' : ''}`}
                                            >
                                                Candidate Unapproved
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                    </div>

                                </Col>

                                {/* Search Status Dropdown */}
                                <Col xs="auto" className="mb-2">
                                    <div className="dropdown-select-wrapper">
                                        <NavDropdown
                                            id="search-status-dropdown"
                                            title={searchStatus || "Search Status"}
                                            className="custom-approval-dropdown"
                                        >
                                            {["", "ACTIVE", "DEACTIVATED"].map((val) => (
                                                <NavDropdown.Item
                                                    key={val || "all"}
                                                    onClick={() => { setSearchStatus(val); searchCandidate(); }}
                                                    className={`unapproved-dropdown-item ${searchStatus === val ? "active" : ""}`}
                                                >
                                                    {val || "All"}
                                                </NavDropdown.Item>
                                            ))}
                                        </NavDropdown>
                                    </div>
                                </Col>

                                {/* Validation Status Dropdown */}
                                <Col xs="auto" className="mb-2">
                                    <div className="dropdown-select-wrapper">
                                        <NavDropdown
                                            id="validation-status-dropdown"
                                            title={validationStatus || "Validation Status"}
                                            className="custom-approval-dropdown"
                                        >
                                            {["", "UNVALIDATED", "VALIDATED", "DEACTIVATED"].map((val) => (
                                                <NavDropdown.Item
                                                    key={val || "all"}
                                                    onClick={() => { setValidationStatus(val); searchCandidate(); }}
                                                    className={`unapproved-dropdown-item ${validationStatus === val ? "active" : ""}`}
                                                >
                                                    {val || "All"}
                                                </NavDropdown.Item>
                                            ))}
                                        </NavDropdown>
                                    </div>
                                </Col>
                                {/* <Col xs="auto" className="mb-2">
                                    <SigniteButton type="button" variant="primary" className="ms-2" onClick={searchCandidate}>
                                        <FontAwesomeIcon icon={faSearch} size="sm" /> <span>Search</span>
                                    </SigniteButton>
                                </Col> */}
                            </Row>
                        </Form>

                    </Card.Header>
                    <Card.Body>
                        {(() => {
                            window.onCandidateApproved = () => {
                                queryClient.invalidateQueries(['data']);
                            };
                        })()}
                        <CandidatesTable
                            key={filterKey}
                            tableKey="unapproved"
                            columns={columns}
                            fetchData={fetchData}
                            candidateId={updatedCandidateId}
                            firstName={updatedFirstName}
                            lastName={updatedLastName}
                            designation={updatedDesignation}
                            yearsOfExp={updatedYearsOfExp}
                            searchLocation={updatedSearchLocation}
                            industry={updatedIndustry}
                            ctcMin={updatedCtcMin}
                            ctcMax={updatedCtcMax}
                            candidateApproved={candidateApproved}
                        />
                    </Card.Body>

                </Card>
            </Row>
        </Container>
    );
};

export default UnapprovedCandidates;
